import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

/**
 * The "member" side of Rekebisha: the same `rekebishaapp` Firebase project the mobile
 * app authenticates against. Contact-detail visibility and reviews live here, not in
 * the fundi-profile project (RekebishaAdmin/config.js) or the rental-manager project
 * (RentalManager/config.js) — this is deliberately a fourth, separate connection so a
 * review or contact-tap made from the website lands in the exact same place the app
 * reads from.
 *
 * Kept a named app (like the website's other Firebase connections) so it can live
 * alongside them without clashing with the default app.
 */
const firebaseConfig = {
  apiKey: "AIzaSyA35tDTwqfgVjq5B9ImzQT9s9i1v15ZkvE",
  authDomain: "rekebishaapp.firebaseapp.com",
  databaseURL: "https://rekebishaapp-default-rtdb.firebaseio.com",
  projectId: "rekebishaapp",
  storageBucket: "rekebishaapp.appspot.com",
  messagingSenderId: "869728077538",
  appId: "1:869728077538:web:be42ce795dbcec341740bb",
  measurementId: "G-Q9V25PRBFF",
};

const membersApp = firebase.initializeApp(firebaseConfig, "rekebishaMembers");

export const db = membersApp.firestore();
export const auth = membersApp.auth();
